var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.36 12.856-6.666 8a1.334 1.334 0 0 1-1.967.089l-4-4 1.885-1.886 2.968 2.968 5.732-6.879 2.048 1.708Z",
    fill: "#FFA0CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.997 5.33a10.667 10.667 0 1 0 0 21.334 10.667 10.667 0 0 0 0-21.333ZM6.57 6.57a13.333 13.333 0 1 1 18.857 18.856A13.333 13.333 0 0 1 6.569 6.569Z",
    fill: "#FFA0CC"
  })));
};

export default SvgCheckCircle;